module.exports = __webpack_public_path__ + "img/text_align_center.eb2db875.svg";